<script setup>
import { computed } from 'vue';
import { formatEgyptTime } from '@/composables/examError';

const props = defineProps({
  state: { type: Object, required: true },
});
const emit = defineEmits(['retry']);

const icons = {
  search: '🔍', lock: '🔒', clock: '⏰', alert: '⚠️', check: '✅', wifi: '📡',
};
const icon = computed(() => icons[props.state?.icon] || '⚠️');
const startText = computed(() =>
  props.state?.startAt ? formatEgyptTime(props.state.startAt) : ''
);
</script>

<template>
  <div class="exam-error">
    <div class="exam-error-card">
      <div class="exam-error-icon">{{ icon }}</div>
      <h2 class="exam-error-title">{{ state.title }}</h2>
      <p class="exam-error-msg">{{ state.message }}</p>
      <p v-if="startText" class="exam-error-time">موعد بداية الامتحان: {{ startText }}</p>
      <p v-if="state.secondary" class="exam-error-secondary">{{ state.secondary }}</p>

      <button
        v-if="state.action && state.action.retry"
        class="exam-error-btn"
        type="button"
        @click="emit('retry')"
      >{{ state.action.label }}</button>
      <router-link
        v-else-if="state.action && state.action.to"
        :to="state.action.to"
        class="exam-error-btn"
      >{{ state.action.label }}</router-link>
    </div>
  </div>
</template>

<style scoped>
.exam-error {
  direction: rtl;
  font-family: 'Cairo', sans-serif;
  min-height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1rem 96px;
  background: #F5F7FB;
}
.exam-error-card {
  background: #fff;
  border-radius: 20px;
  border: 1px solid rgba(91, 95, 239, .1);
  box-shadow: 0 8px 30px rgba(17, 24, 39, .07);
  max-width: 440px;
  width: 100%;
  text-align: center;
  padding: 2.25rem 1.5rem;
}
.exam-error-icon { font-size: 3.25rem; line-height: 1; margin-bottom: .75rem; }
.exam-error-title { font-size: 1.35rem; font-weight: 800; color: #1A1A1A; margin-bottom: .5rem; }
.exam-error-msg { font-size: .95rem; color: #4B5563; line-height: 1.7; }
.exam-error-time {
  font-size: .88rem;
  font-weight: 700;
  color: #5B5FEF;
  background: rgba(91, 95, 239, .08);
  border-radius: 10px;
  padding: .5rem .8rem;
  margin: .85rem 0 0;
}
.exam-error-secondary { font-size: .82rem; color: #9CA3AF; line-height: 1.7; margin-top: .6rem; }
.exam-error-btn {
  display: inline-block;
  margin-top: 1.4rem;
  text-decoration: none;
  cursor: pointer;
  border: none;
  font-family: 'Cairo', sans-serif;
  font-weight: 700;
  font-size: .95rem;
  color: #fff;
  background: linear-gradient(135deg, #5B5FEF, #7C4DFF);
  padding: .7rem 1.8rem;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(91, 95, 239, .28);
  transition: transform .15s, box-shadow .2s;
}
.exam-error-btn:active { transform: scale(.98); }
</style>
